import { formatPercentageInputValue, percentageMask } from "../../utils/admin-utils";

export const declineNetSalesFormConfig = ({ declineNetSales } = {}) => {
	return [
		{
            fields: [
                {
                    name: "declineGreaterThan",
                    label: "% de queda (maior que) *",
                    type: "text",
                    placeholder: "0",
                    defaultValue: formatPercentageInputValue(declineNetSales?.declineGreaterThan),
                    columns: 12,
                    onChange: percentageMask
                },
                {
                    name: "penalty",
                    label: "% de penalidade *",
                    type: "text",
                    placeholder: "0",
                    defaultValue: formatPercentageInputValue(declineNetSales?.penalty),
                    columns: 12,
                    onChange: percentageMask
                }
            ]
        }
	];
};